function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { Button } from '../Button';

var Actions = function Actions(_ref) {
  var actions = _ref.actions;
  return /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, actions.map(function (action) {
    return /*#__PURE__*/React.createElement(Button, _extends({
      key: action.name
    }, action), action.name);
  }));
};

Actions.displayName = 'Actions';
var ActionsDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  ActionsDoc = require('./doc').doc(Actions);
}

var ActionsWrapper = ActionsDoc || Actions;
export { ActionsWrapper as Actions };